import { render, staticRenderFns } from "./GameModal.vue?vue&type=template&id=55bb65c6&"
import script from "./GameModal.vue?vue&type=script&lang=js&"
export * from "./GameModal.vue?vue&type=script&lang=js&"
import style0 from "./GameModal.vue?vue&type=style&index=0&id=55bb65c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports